import { Input, Popover } from 'element-ui';
import { EventBus } from '@/services/Event.js';
import DisabledValue from '../disabled-value/disabled-value.vue';

export default {
    name: 'NumberAnswer',
    props: {
        id: [Number, String],
        value: Number,
        label: String,
        label_class: {
            type: String,
            default: ''
        },
        disabled: Boolean,
        visible: {
            type: Boolean, default: true
        },
        hint: String,
        warning_field_length: String,
        error_messages: Array,
        hint_type: { type: String, default: 'warning' },
        preview: { type: Boolean, default: false },
        valid: { type: Boolean, default: true },
        min_value: { type: Number, default: null},
        max_value: { type: Number, default: null },
        is_mandatory: Boolean,
        is_mandatory_if_visible: Boolean,
        is_integer: Boolean,
        min_value_dependent_value: { type: Number, default: 0 },
        precision: { type: Number, default: 0 },
        default_value: { type: Number, default: 0 },

        smallest: { type: String, default: 'col-12' },
        small: { type: String, default: 'col-sm-12' }, medium: { type: String, default: 'col-md-12' }, large: { type: String, default: 'col-lg-12' }, largest: { type: String, default: 'col-lg-12' }
    },
    components: {
        [Input.name]: Input,
        [Popover.name]: Popover,
        'disabled-value': DisabledValue
    },
    computed: {
        column_class() {
            return `${this.largest} ${this.large} ${this.medium} ${this.small} ${this.smallest}`
        },
        label_class_value() {
            return "float-left"
        },
        is_min_max_empty_null_or_zero() {
            return (!this.is_number(this.min_value) && !this.is_number && this.max_value) || (this.min_value == 0 && this.max_value == 0);
        }
    },
    watch: {
        value: { // watch it
            immediate: true,
            handler(val, oldVal) {
                if (val != oldVal) {
                    this.prop_value = val;
                    this.handler_change();
                }
            }
        }
    },
    data() {
        return {
            replace_min_value: '-min_value-',
            replace_max_value: '-max_value-',
            replace_field_name: '-field_name-',

            warning_value: "",
            warning_min_value: "",
            warning_max_value: "",
            warning_mandatory: "This field is mandatory to fill",

            min_value_now: this.min_value,
            prop_value: this.value,
            prop_valid: this.valid
        };
    },
    methods: {
        is_number(value) {
            return value > 0 || value == 0 || value < 0;
        },
        validate() {
            let new_warnings = [];
            let isNeedValueMinMaxWarning = false;

            if (!this.is_mandatory && !this.is_mandatory_if_visible) {
                if (this.is_number(this.prop_value) && !this.is_min_max_empty_null_or_zero) {
                    isNeedValueMinMaxWarning = true;
                }
                else {
                    //no value no check
                }
            }
            else { //if mandatory
                if (!this.is_number(this.prop_value) && this.is_min_max_empty_null_or_zero) {
                    new_warnings.push(this.warning_mandatory);
                } else {
                    isNeedValueMinMaxWarning = true;
                }
            }

            if (isNeedValueMinMaxWarning) {
                let templateWarning = "";
                if (this.is_number(this.max_value) &&
                    this.is_number(this.min_value)) {

                    if (!this.is_number(this.prop_value) ||
                        this.prop_value < this.min_value ||
                        this.prop_value > this.max_value) {
                        templateWarning = this.warning_value;
                    }
                }
                else
                    if (this.is_number(this.max_value)) {
                        if (!this.is_number(this.prop_value) || this.prop_value > this.max_value) {
                            templateWarning = this.warning_max_value;
                        }
                    }
                    else if (this.is_number(this.min_value)) {
                        if (!this.is_number(this.prop_value) ||this.prop_value < this.min_value) {
                            templateWarning = this.warning_min_value;
                        }
                    }

                if (templateWarning) {
                    new_warnings.push(templateWarning);
                }
            }

            this.prop_valid = !new_warnings.length;
            this.$emit("update:valid", this.prop_valid);
            this.$emit("update:error_messages", new_warnings);
        },
        handler_change() {
            this.validate();
            this.$emit("update:value", this.prop_value);

            if (this.min_value_dependent_value > 0) {
                EventBus.$emit(`update-min-value-id-${this.min_value_dependent_value}`, this.prop_value)
            }
        },
        remove_tab_index() {
            if (this.$refs && Object.keys(this.$refs).length) {
                Object.keys(this.$refs).forEach(prop => {
                    if (this.$refs[prop] && this.$refs[prop].$el && this.$refs[prop].$el.children && this.$refs[prop].$el.children.length) {
                        this.$refs[prop].$el.children[1].tabIndex = -1;
                    }
                })
            }
        },
    },
    mounted() {
        var self = this;
        self.warning_value = `This field value should be between or equal to ${this.min_value} and ${this.max_value}`;
        self.warning_min_value = `This field value should be more than or equal to ${this.min_value}`;
        self.warning_max_value = `This field value should be until or equal to ${this.max_value}`;

        this.prop_value = !this.is_number(this.value) && this.is_number(this.default_value) &&
            (!this.is_number(this.min_value) || this.default_value >= this.min_value) &&
            (!this.is_number(this.max_value) || this.default_value <= this.max_value)
                ? this.default_value
                : this.value >= this.min_value && this.value <= this.max_value
                    ? this.value
                    : this.min_value;

        this.prop_valid = this.valid;
        this.handler_change();
        EventBus.$off(`update-min-value-id-${this.id}`)
        EventBus.$on(`update-min-value-id-${this.id}`, currentValue => {
            self.min_value_now = currentValue
            if (self.prop_value < self.min_value_now) {
                self.prop_value = self.min_value_now;
                self.handler_change();
            }
        });
        self.remove_tab_index();
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/number/number.js